import { useEffect } from 'react';
import { initializeHaptics } from '../../utils/hapticHelper';

/**
 * HapticProvider - Initializes global haptic feedback
 * Place this component at the root of your app
 */
const HapticProvider = ({ children }) => {
  useEffect(() => {
    // Only initialize on touch devices
    const isTouchDevice = 'ontouchstart' in window || navigator.maxTouchPoints > 0;
    
    if (isTouchDevice) {
      initializeHaptics();
    }
  }, []);

  return children;
};

export default HapticProvider;

